import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom'

// import { TelaCadastrar } from '../pages/Tela Cadastrar/TelaCadastrar'
import { AuthProvider } from '../contexts/AuthContext'
import { LoginContainer } from '../pages/Login/LoginContainer'
import { PrivateRoute } from './PrivateRoute'
import { Layout } from '../components/Layout'
import { PortalConhecimentoContainer } from '../pages/PortalConhecimento/PortalConhecimentoContainer'
import { HomeContainer } from '../pages/Home/HomeContainer'
import { TreinamentosContainer } from '../pages/Treinamentos/TreinamentosContainer'
import { TelaMapaUtilizacao } from '../pages/MapaUtilizacao/MapaUtilizacao'
import { ReleasedVersionsContainer } from '../pages/VersoesLiberadas/VersoesLiberadasContainer'
import { CadastrarTicketContainer } from '../pages/CadastrarTicket/CadastrarTicketContainer'
import { MeusTicketsContainer } from '../pages/MeusTickets/MeusTicketsContainer'
import { TicketDetailsContainer } from '../pages/TicketDetails/TicketDetailsContainer'
import { FeedbackContainer } from '../pages/MeusTickets/Feedback/FeedbackContainer'


const Routers = () => (
  <BrowserRouter>
    <AuthProvider>
      <Routes>
        <Route path="/" element={<LoginContainer />}></Route>

        <Route
          element={
            <PrivateRoute>
              <Layout />
            </PrivateRoute>
          }
        >
          <Route path="/home" element={<HomeContainer />}></Route>
          <Route path="/portal-conhecimento">
            <Route index element={<Navigate to="home" replace />} />
            <Route path=":id" element={<PortalConhecimentoContainer />} />
          </Route>
          <Route path="/cadastrar-ticket" element={<CadastrarTicketContainer />}></Route>
          <Route path="/tickets" element={<MeusTicketsContainer />}></Route>
          <Route path="/tickets/:id" element={<TicketDetailsContainer />}></Route>
          <Route path="/tickets/feedback/:id" element={<FeedbackContainer />}></Route>
          <Route path="/versoes-liberadas" element={<ReleasedVersionsContainer />}></Route>
          <Route path="/treinamentos-recebidos" element={<TreinamentosContainer />}></Route>
          <Route path="/mapa-utilizacao" element={<TelaMapaUtilizacao />}></Route>
        </Route>
      </Routes>
    </AuthProvider>
  </BrowserRouter>
)

export default Routers
